exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ir_Wr{position:absolute;top:0;right:0;bottom:0;left:0;display:flex;flex-direction:column}.ir_Wr ._3BQke{position:relative;flex-grow:2}", ""]);

// exports
exports.locals = {
	"mainUiBlock": "ir_Wr",
	"tooltipContainerWrapper": "_3BQke"
};